
  import { Options, Vue } from 'vue-class-component'; 
  import $ from 'jquery';
  import Axios from "axios";   
  import { Form, Field,ErrorMessage } from 'vee-validate';
  import { useToast } from "vue-toastification";
  import Common from '@/services/common.js'; 
  import Loader from '@/components/Loader.vue';   
  import 'bootstrap'; 
  @Options({
    props: {
        beneficiary_id: Number,
        reload_b      : Number, 
        beneficiary_on: Number, 
        countries     : [Number, String],
    },
    components: {    
        'loader':Loader,
        Form,
        Field,
        ErrorMessage
    },
  })
  export default class Beneficiary extends Vue { 
    STORAGE_KEY     =   "caprock-local";  
    token           =   ''; 
    session = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || "{}");

    beneficiary_id;           
    beneficiary_on;   
    load_on:any=0;     
    countries;   
    reload_b;

    local_storage:any={};
    bform :any = {}; 

    /*STEP 2*/
      s2_image_url :any   =   null; 
      s2_doc_url   :any   =   null;
      s2_not_image :any   =   null;
      s2_doc_path  :any   =   null;
      file_s2_name:any    =   null; 
      trust_deed:any =  null;

    /*Place*/
        timer :any          = undefined;
        place_suggestion = false;
        place_list:any[]= []; 

    toast:any = useToast();

    svg_image:any='<svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 100 100" width="50px" height="50px">    <path d="M 34.179688 10.164062 C 32.103687 10.164062 30.615234 11.426266 30.615234 13.697266 L 30.648438 25.806641 C 30.648438 28.846641 32.770234 30.712891 35.615234 30.712891 C 38.460234 30.712891 40.615234 29.002891 40.615234 25.962891 L 40.615234 14.306641 L 39.613281 14.306641 L 39.523438 25.869141 C 39.523438 28.079141 37.599438 29.808594 35.648438 29.808594 C 33.697437 29.808594 31.615234 28.049844 31.615234 25.839844 L 31.644531 13.611328 C 31.644531 12.304328 33.077484 11.126953 34.271484 11.126953 C 35.465484 11.126953 36.615234 12.275031 36.615234 13.582031 L 36.615234 24.056641 C 36.615234 24.056641 36.139813 25.056641 35.632812 25.056641 C 35.125812 25.056641 34.486234 24.700391 34.615234 24.150391 L 34.615234 14.308594 L 33.615234 14.308594 L 33.582031 23.964844 C 33.582031 25.344844 34.32225 25.964844 35.65625 25.964844 C 36.99025 25.964844 37.615234 25.249141 37.615234 23.869141 L 37.615234 13.664062 C 37.615234 11.393062 36.255687 10.164062 34.179688 10.164062 z M 41.613281 11.306641 C 41.061281 11.306641 40.613281 11.754641 40.613281 12.306641 C 40.613281 12.858641 41.061281 13.306641 41.613281 13.306641 L 59.613281 13.306641 L 59.613281 23.792969 C 59.613281 29.039969 63.881906 33.306641 69.128906 33.306641 L 79.613281 33.306641 L 79.613281 82.574219 C 79.613281 86.837219 76.146812 90.306641 71.882812 90.306641 L 28.347656 90.306641 C 24.084656 90.306641 20.615234 86.838219 20.615234 82.574219 L 20.615234 21.039062 C 20.615234 16.776063 24.083656 13.308594 28.347656 13.308594 L 29.615234 13.308594 C 30.167234 13.308594 30.615234 12.860594 30.615234 12.308594 C 30.615234 11.756594 30.167234 11.308594 29.615234 11.308594 L 28.347656 11.308594 C 22.981656 11.308594 18.615234 15.672062 18.615234 21.039062 L 18.615234 82.574219 C 18.615234 87.940219 22.980656 92.306641 28.347656 92.306641 L 71.882812 92.306641 C 77.248812 92.306641 81.613281 87.940219 81.613281 82.574219 L 81.613281 32.554688 C 81.613281 32.289688 81.508313 32.035656 81.320312 31.847656 L 61.072266 11.599609 C 60.885266 11.411609 60.630234 11.306641 60.365234 11.306641 L 41.613281 11.306641 z M 60.613281 13.966797 L 78.951172 32.306641 L 69.128906 32.306641 C 64.433906 32.306641 60.613281 28.487969 60.613281 23.792969 L 60.613281 13.966797 z M 28.371094 19.505859 C 28.245219 19.481734 28.110094 19.505984 27.996094 19.583984 C 25.878094 21.023984 24.613281 23.406078 24.613281 25.955078 L 24.613281 78.617188 C 24.613281 82.856187 28.048484 86.306641 32.271484 86.306641 L 67.955078 86.306641 C 72.178078 86.306641 75.613234 82.856188 75.615234 78.617188 L 75.615234 60.806641 C 75.615234 60.530641 75.391234 60.306641 75.115234 60.306641 C 74.839234 60.306641 74.615234 60.530641 74.615234 60.806641 L 74.615234 78.617188 C 74.615234 82.305187 71.628031 85.306641 67.957031 85.306641 L 32.273438 85.306641 C 28.602438 85.306641 25.615234 82.305188 25.615234 78.617188 L 25.615234 25.955078 C 25.615234 23.737078 26.714594 21.664156 28.558594 20.410156 C 28.786594 20.255156 28.846406 19.945797 28.691406 19.716797 C 28.613906 19.603297 28.496969 19.529984 28.371094 19.505859 z M 75.113281 47.306641 C 74.837281 47.306641 74.613281 47.530641 74.613281 47.806641 L 74.613281 50.806641 C 74.613281 51.082641 74.837281 51.306641 75.113281 51.306641 C 75.390281 51.306641 75.613281 51.082641 75.613281 50.806641 L 75.613281 47.806641 C 75.613281 47.530641 75.389281 47.306641 75.113281 47.306641 z M 30.113281 51.306641 C 29.837281 51.306641 29.613281 51.530641 29.613281 51.806641 C 29.613281 52.082641 29.837281 52.306641 30.113281 52.306641 L 53.113281 52.306641 C 53.390281 52.306641 53.613281 52.082641 53.613281 51.806641 C 53.613281 51.530641 53.389281 51.306641 53.113281 51.306641 L 30.113281 51.306641 z M 75.113281 52.306641 C 74.837281 52.306641 74.613281 52.530641 74.613281 52.806641 L 74.613281 58.806641 C 74.613281 59.082641 74.837281 59.306641 75.113281 59.306641 C 75.390281 59.306641 75.613281 59.082641 75.613281 58.806641 L 75.613281 52.806641 C 75.613281 52.530641 75.389281 52.306641 75.113281 52.306641 z M 30.113281 58.306641 C 29.837281 58.306641 29.613281 58.530641 29.613281 58.806641 C 29.613281 59.082641 29.837281 59.306641 30.113281 59.306641 L 44.113281 59.306641 C 44.390281 59.306641 44.613281 59.082641 44.613281 58.806641 C 44.613281 58.530641 44.389281 58.306641 44.113281 58.306641 L 30.113281 58.306641 z M 46.113281 58.306641 C 45.837281 58.306641 45.613281 58.530641 45.613281 58.806641 C 45.613281 59.082641 45.837281 59.306641 46.113281 59.306641 L 70.113281 59.306641 C 70.390281 59.306641 70.613281 59.082641 70.613281 58.806641 C 70.613281 58.530641 70.389281 58.306641 70.113281 58.306641 L 46.113281 58.306641 z M 30.113281 65.306641 C 29.837281 65.306641 29.613281 65.530641 29.613281 65.806641 C 29.613281 66.082641 29.837281 66.306641 30.113281 66.306641 L 48.113281 66.306641 C 48.390281 66.306641 48.613281 66.082641 48.613281 65.806641 C 48.613281 65.530641 48.389281 65.306641 48.113281 65.306641 L 30.113281 65.306641 z M 50.113281 65.306641 C 49.837281 65.306641 49.613281 65.530641 49.613281 65.806641 C 49.613281 66.082641 49.837281 66.306641 50.113281 66.306641 L 61.113281 66.306641 C 61.390281 66.306641 61.613281 66.082641 61.613281 65.806641 C 61.613281 65.530641 61.389281 65.306641 61.113281 65.306641 L 50.113281 65.306641 z M 63.113281 65.306641 C 62.837281 65.306641 62.613281 65.530641 62.613281 65.806641 C 62.613281 66.082641 62.837281 66.306641 63.113281 66.306641 L 71.113281 66.306641 C 71.390281 66.306641 71.613281 66.082641 71.613281 65.806641 C 71.613281 65.530641 71.389281 65.306641 71.113281 65.306641 L 63.113281 65.306641 z M 30.113281 72.306641 C 29.837281 72.306641 29.613281 72.530641 29.613281 72.806641 C 29.613281 73.082641 29.837281 73.306641 30.113281 73.306641 L 54.113281 73.306641 C 54.390281 73.306641 54.613281 73.082641 54.613281 72.806641 C 54.613281 72.530641 54.389281 72.306641 54.113281 72.306641 L 30.113281 72.306641 z M 57.113281 72.306641 C 56.837281 72.306641 56.613281 72.530641 56.613281 72.806641 C 56.613281 73.082641 56.837281 73.306641 57.113281 73.306641 L 70.113281 73.306641 C 70.390281 73.306641 70.613281 73.082641 70.613281 72.806641 C 70.613281 72.530641 70.389281 72.306641 70.113281 72.306641 L 57.113281 72.306641 z"/></svg>';



    data () {       
        return {  
            beneficiary_on:this.beneficiary_on,
            load_on:this.load_on,
            beneficiary_id:this.beneficiary_id ,
            countries:this.countries ,
            reload_b:this.reload_b 
        } 
    }   

    /*Google Place API*/
        textSearch(e:any){
            clearTimeout(this.timer) 
            this.timer = setTimeout(() => {
                Common.get_place_search(e.target.value)
                .then(response => {   
                if(response.status==200 && (response.data.data.results).length>0){
                    var places = response.data.data.results;   
                    $('.suggestDiv').removeClass('d-none');
                    this.place_list = [];
                    this.place_suggestion=true;
                    var list_ar:any[] = []
                    for (var i = 0; i < places.length; i++) {  
                        if(i<5){
                            var suggest     = places[i]; 
                            var input_address =  suggest.name+" "+ suggest.formatted_address;
                            if(suggest.formatted_address.includes(suggest.name)){
                                input_address = suggest.formatted_address;
                            } 
                            this.place_list.push({
                                id      :   i+1,
                                title   :   suggest.name,
                                details :   suggest.formatted_address,
                                address :   input_address,
                                lat     :   suggest.geometry.location.lat,
                                long    :   suggest.geometry.location.lng  
                            });  
                        }
                    } 
                    $('.addr_section').addClass('m-0');
                    $('.place_suggest').removeClass('d-none'); 
                } 

                }).catch(e => {
                  console.log(e)
                });
            }, 100)
        }
        set_address(id){
            $('#addr_'+id).removeClass('d-none');    
            var add = $('#addr_'+id).text(); 
            this.bform['beneficiary_home_address']=add;   
            $('#addr_'+id).addClass('d-none');    
            $('.place_suggest').addClass('d-none');    
            $('.addr_section').removeClass('m-0');  
        }

    created(){
      var js =this.local_storage=JSON.parse((localStorage.getItem(this.STORAGE_KEY) || "{}"));    
      return true;
    }
    closeModal(id: any) {
      $('#' + id).removeClass('d-block');
      $('#' + id).addClass('d-none');
      $('#' + id).removeClass('show'); 
    } 
    openModal(id: any) {
      $('#' + id).addClass('d-block');
      $('#' + id).removeClass('d-none');
      $('#' + id).addClass('d-block');
      $('#' + id).addClass('show'); 
    } 
    openDoc(path){ 
        window.open(path,'_blank');
    }
    uploadFile(event){ 
      var path_item       = event.target.name+'_path';
      var item_url        = event.target.name+'_url';
      var pbar            = event.target.name+'_pbar';
      var pbarp           = event.target.name+'_pbar_p'; 
      var pdiv            = event.target.name+'_pdiv';

      this.bform[pdiv]     =   1;   
      this.bform[pbar]     =   0;   
      this.bform[pbarp]    =  '0%';    

      
      var file        = event.target.files[0];   
      let form_data   = new FormData();  
      form_data.append('user_token',this.local_storage['access-token']);

      if(typeof file !='undefined' && file!=null){
          form_data.append('file',file); 

          Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
          var url =Common.base_url()+'upload-file';    
          Axios.post(
              url, 
              form_data, 
              {
                  headers: {  
                      'Content-Type': 'multipart/form-data'
                  }, 
                  onUploadProgress: progressEvent => {
                      var loaded:number   =   progressEvent.loaded; 
                      var total:number    =   progressEvent.total;
                      var per             =   parseInt((loaded/total *100).toFixed());   
                      this.bform[pbar]     =   per; 
                      this.bform[pbarp]    =   per+'%';  

                      if(per==100){
                          this.bform[pbarp]    =   'Processing';  
                      } 
                  }, 
              }
          )
          .then(response => { 
              if(response.data.success==200){  
                  this.bform[pbarp]        =   'Upload Success';  
                  this.bform[path_item]    =   response.data.file_path;     
                  this.bform[item_url]     =   response.data.file_url;    
              }else{
                  this.bform[pdiv] =   0;   
                  this.bform[pbar] =   0;
                  this.bform[pbarp]=   '0%';
                   
                  this.toast.info(response.data.message);  
              } 
          })
          .catch(error => {
              this.bform[pdiv] =   0;   
              this.bform[pbar] =   0;
              this.bform[pbarp]=   'Failed to upload';   
              this.toast.error('Failed to upload');   
              return false;
          });  

      }else{ 
          this.toast.info('Please select file first');   
      }

    }

    fetch_file_bf(event:any){  
      var file = event.target.files[0];   
      if(event.target.name=='trust_deed') {
        this.trust_deed= file; 
      } 
    }
    onFileChange_bf(e) {
          const file = e.target.files[0];
          if(['image/png','image/jpeg','image/svg'].includes(file['type'])){
              this.s2_image_url = URL.createObjectURL(file);    
              this.file_s2_name = null;
              this.s2_not_image = 0;
          }else{
              this.s2_image_url   =   '';  
              this.s2_not_image   =   1;
              const lastDot       =   file['name'].lastIndexOf('.');
              this.file_s2_name   =   (file['name'].substring(lastDot + 1)).toUpperCase();
          }
      } 
      s2LoadError(){
          this.s2_not_image=1;
          this.s2_doc_path =this.s2_image_url;
          this.s2_image_url=''; 
      }


    updateBeneficiary(){
        this.load_on=1; 
       

        var form_records    =   JSON.parse(JSON.stringify((this.bform)));   
        let form_data       =   new FormData();  
      
        var is_colour_passport              =  typeof form_records['is_colour_passport']!='undefined' ? form_records['is_colour_passport'] :'';
        var colour_passport_path            =  typeof form_records['colour_passport_path']!='undefined' ? form_records['colour_passport_path'] :'';

        var is_residence_proof              =  typeof form_records['is_residence_proof']!='undefined' ? form_records['is_residence_proof'] :'';
        var residence_proof_path            =  typeof form_records['residence_proof_path']!='undefined' ? form_records['residence_proof_path'] :'';
      
        var is_contract_proof               =  typeof form_records['is_contract_proof']!='undefined' ? form_records['is_contract_proof'] :'';
        var contract_proof_path             =  typeof form_records['contract_proof_path']!='undefined' ? form_records['contract_proof_path'] :'';
      
        var is_incorporation_certi          =  typeof form_records['is_incorporation_certi']!='undefined' ? form_records['is_incorporation_certi'] :'';
        var incorporation_certi_path        =  typeof form_records['incorporation_certi_path']!='undefined' ? form_records['incorporation_certi_path'] :'';
      
        var is_driver_license               =  typeof form_records['is_driver_license']!='undefined' ? form_records['is_driver_license'] :'';
        var driver_license_path             =  typeof form_records['driver_license_path']!='undefined' ? form_records['driver_license_path'] :'';

        form_data.append('user_token'                   ,this.local_storage['access-token']); 
      
        form_data.append('is_colour_passport'           ,is_colour_passport);
        form_data.append('colour_passport_path'         ,colour_passport_path);
      
        form_data.append('is_residence_proof'           ,is_residence_proof);
        form_data.append('residence_proof_path'         ,residence_proof_path);

        form_data.append('is_contract_proof'            ,is_contract_proof);
        form_data.append('contract_proof_path'          ,contract_proof_path); 
      
        form_data.append('is_incorporation_certi'       ,is_incorporation_certi);
        form_data.append('incorporation_certi_path'     ,incorporation_certi_path); 
      
        form_data.append('is_driver_license'            ,is_driver_license);
        form_data.append('driver_license_path'          ,driver_license_path);


        form_data.append('beneficiary_type',form_records['beneficiary_type']);
        form_data.append('beneficiary_id',form_records['beneficiary_id']);
        form_data.append('beneficiary_name',form_records['beneficiary_name']);
        form_data.append('beneficiary_company_reg_no',form_records['beneficiary_company_reg_no']);
        form_data.append('beneficiary_structure',form_records['beneficiary_structure']);
        form_data.append('beneficiary_nationality',form_records['beneficiary_nationality']);
        form_data.append('beneficiary_reg_country',form_records['beneficiary_reg_country']) ;
 
        form_data.append('beneficiary_passport_no',form_records['beneficiary_passport_no']) ;
        form_data.append('beneficiary_passport_expiry',form_records['beneficiary_passport_expiry']) ;
        form_data.append('beneficiary_passport_country',form_records['beneficiary_passport_country']) ;
        form_data.append('beneficiary_passport_no',form_records['beneficiary_passport_no']) ;
        form_data.append('beneficiary_dob',form_records['beneficiary_dob']) ;
        form_data.append('beneficiary_home_address',form_records['beneficiary_home_address']) ;
        form_data.append('beneficiary_email_id',form_records['beneficiary_email_id']) ;
        form_data.append('beneficiary_phone_no',form_records['beneficiary_phone_no']) ;
        form_data.append('beneficiary_trust',form_records['beneficiary_trust']) ;
        form_data.append('beneficiary_usa_citizen',form_records['beneficiary_usa_citizen']) ;
        form_data.append('beneficiary_tax_resident_usa',form_records['beneficiary_tax_resident_usa'])  ;
        form_data.append('beneficiary_social_security_no',form_records['beneficiary_social_security_no'])    ;
        form_data.append('beneficiary_tax_id',form_records['beneficiary_tax_id']);
        
        form_data.append('beneficiary_bank_name',      form_records['beneficiary_bank_name']); 
        form_data.append('beneficiary_bank_swift_code',      form_records['beneficiary_bank_swift_code']);                 
        form_data.append('beneficiary_bank_ac_name',      form_records['beneficiary_bank_ac_name']);              
        form_data.append('beneficiary_bank_ac_no',      form_records['beneficiary_bank_ac_no']);                
        form_data.append('beneficiary_bank_address',      form_records['beneficiary_bank_address']);              
        form_data.append('beneficiary_ref_no',      form_records['beneficiary_ref_no']);                    
        form_data.append('beneficiary_your_ref_no',      form_records['beneficiary_your_ref_no']);     
        form_data.append('beneficiary_payment_transmission_type',      form_records['beneficiary_payment_transmission_type']);
        form_data.append('beneficiary_bank_officer_name',      form_records['beneficiary_bank_officer_name']);         
        form_data.append('beneficiary_bank_officer_phone_no',      form_records['beneficiary_bank_officer_phone_no']);     
        form_data.append('beneficiary_bank_officer_email_address',      form_records['beneficiary_bank_officer_email_address']);

        if(typeof this.trust_deed !='undefined' && this.trust_deed!=null){
            form_data.append('trust_deed',this.trust_deed); 
        }



        var message = '';
        var error   = 0; 
        if(error!=0){
            this.toast.error(message); 
           
        }else{  
            Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
            var url =Common.base_url()+'save-beneficiary';   
            Axios.post(
                url, 
                form_data, 
                {
                    headers: {  
                      'Content-Type': 'multipart/form-data'
                    }, 
                    onUploadProgress: progressEvent => {
                        var loaded:number   =   progressEvent.loaded; 
                        var total:number    =   progressEvent.total;
                        var per             =   parseInt((loaded/total *100).toFixed());    
                    }  
                }
            )
            .then(response => { 
                if(response.data.success==200){         
                    setTimeout(() => this.load_on=0, 500); 
                    this.toast.success(response.data.message);   

                    if(this.reload_b==1){
                        setTimeout(() => location.reload(), 2500);  
                    }

                }else{ 
                    setTimeout(() => this.load_on=0, 500); 
                    this.toast.error(response.data.message);   
                } 
            })
            .catch(error => { 
                this.toast.info('Internal Error');  
                setTimeout(() => this.load_on=0, 500); 
            });  
        } 
    } 
    get_beneficiary_info(token,id){  
      Common.get_beneficiary_info(token,id)
          .then(response => {
              if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                var beneficiary   =   response.data.beneficiary;  
                if(typeof beneficiary!='undefined'){
                    var docs          =   JSON.parse(beneficiary['beneficiary_documents']); 
                    this.bform        =   beneficiary;
                  
                    this.bform['is_colour_passport']                 =   typeof docs['is_colour_passport']!='undefined' && docs['is_colour_passport']!=null ?docs['is_colour_passport'].toString():'0';
                    this.bform['colour_passport_path']               =   docs['colour_passport_path'];
                    this.bform['is_residence_proof']                 =   typeof docs['is_residence_proof']!='undefined' && docs['is_residence_proof']!=null ?docs['is_residence_proof'].toString():'0';
                    this.bform['residence_proof_path']               =   docs['residence_proof_path'];
                    this.bform['is_contract_proof']                  =   typeof docs['is_contract_proof']!='undefined' && docs['is_contract_proof']!=null ?docs['is_contract_proof'].toString():'0';
                    this.bform['contract_proof_path']                =   docs['contract_proof_path'];
                    this.bform['is_incorporation_certi']             =   typeof docs['is_incorporation_certi']!='undefined' && docs['is_incorporation_certi']!=null ?docs['is_incorporation_certi'].toString():'0';
                    this.bform['incorporation_certi_path']           =   docs['incorporation_certi_path'];
                    this.bform['is_driver_license']                  =   typeof docs['is_driver_license']!='undefined' && docs['is_driver_license']!=null ?docs['is_driver_license'].toString():'0';
                    this.bform['driver_license_path']                =   docs['driver_license_path']; 

                    this.bform['beneficiary_tax_resident_usa']                  =   typeof docs['beneficiary_tax_resident_usa']!='undefined' && docs['beneficiary_tax_resident_usa']!=null ?docs['beneficiary_tax_resident_usa'].toString():'0';
                    this.bform['beneficiary_usa_citizen']                  =   typeof docs['beneficiary_usa_citizen']!='undefined' && docs['beneficiary_usa_citizen']!=null ?docs['beneficiary_usa_citizen'].toString():'0';
                  
                    this.bform['beneficiary_trust']                  =   typeof beneficiary['beneficiary_trust']!='undefined' && beneficiary['beneficiary_trust']!=null ?beneficiary['beneficiary_trust'].toString():'0';
                    
                    this.bform['trust_deed_url']                    =   typeof beneficiary['trust_deed_url']!='undefined' && beneficiary['trust_deed_url']!=null ?beneficiary['trust_deed_url'] :'';

                    this.s2_image_url       =   this.bform['trust_deed_url'];
                    this.s2_doc_url         =   this.bform['trust_deed_url'];
                    this.file_s2_name       =   beneficiary['file_name']; 
        

                }
 
                        
                // console.log(beneficiary);
                // this.bform        =   beneficiary;   
              }
          }).catch(e => {
            console.log(e)
      });
    }

    /*FORM VALIDATIONS*/  
        validateEmail(value) { 
            const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            if (typeof value!='undefined' && !regex.test(value)) { 
                return 'This field must be a valid email'; 
            } 
            return true;
        }  
        requiredField(value) { 
            if (!value) {
                return 'This field is required';
            } 
            return true;
        }
        selectField(value) { 
            if (!value || value=='') {
                return 'Please select one of option';
            } 
            return true;
        } 
        mobileField(value){ 
            if(typeof value!='undefined'){
                var phoneNum = value.replace(/[^\d]/g, '');
                if(phoneNum.length <7 || phoneNum.length > 12) {  
                    return 'This field must be a valid mobile number';
                }  
                return true;
            }
            return true; 
        } 
 
  }
